import { Center, Flex } from "@chakra-ui/react";
import { useState, useEffect } from "react";
import Pagination from "@material-ui/lab/Pagination";

import BlogCard from "../../../src/components/blog/blogCard";
import Error from "../../../src/components/common/error";
import TopBand from "../../../src/components/common/topBand";
import { fetchProductCategories } from "../../../src/redux/actions";
import { wrapper } from "../../../src/redux/store";
import { ITEMS_PER_PAGE_ODD } from "../../../src/constants";
import { capitalizeFirstLetter } from "../../../src/utils/functions";

import {
  fetchBlogCategories,
  fetchBlogsForCategorySlug,
} from "../../../src/services/blogService";

export default function Blog(props) {
  if (props.errorMessage) {
    return <Error errorMessage={errorMessage} />;
  }

  const [page, setPage] = useState(1);
  const blogs = JSON.parse(props.blogs);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page]);

  const title = `${capitalizeFirstLetter(
    props.slug.split("-").join(" ")
  )} blogs`;

  return (
    <>
      <TopBand title={title ? title : "Blogs"} />
      <Center mt="10" flexDirection="column">
        <Flex
          flexWrap="wrap"
          width={{ xl: "90%", "2xl": "1350px" }}
          justifyContent={{
            base: "center",
            md: "space-around",
            lg: "space-around",
            xl: "space-between",
            "2xl": "space-between",
          }}
        >
          {blogs &&
            blogs
              .slice((page - 1) * ITEMS_PER_PAGE_ODD, page * ITEMS_PER_PAGE_ODD)
              .map((blog) => <BlogCard blog={blog} />)}
        </Flex>
      </Center>
      <Center my="10">
        <Pagination
          page={page}
          size="large"
          color="primary"
          variant="outlined"
          onChange={(event, val) => setPage(val)}
          count={blogs ? Math.ceil(blogs.length / ITEMS_PER_PAGE_ODD) : 0}
        />
      </Center>
    </>
  );
}

export const getStaticProps = wrapper.getStaticProps(
  (store) =>
    async ({ params }) => {
      const { slug } = params;
      try {
        await store.dispatch(fetchProductCategories());
        const blogs = await fetchBlogsForCategorySlug(slug);

        return {
          props: { blogs: JSON.stringify(blogs), slug },
        };
      } catch (err) {
        return {
          props: {
            blog: {},
            errorMessage: err.message,
          },
        };
      }
    }
);

export async function getStaticPaths() {
  try {
    const categories = await fetchBlogCategories();
    const paths = categories.map(({ slug }) => ({
      params: { slug },
    }));

    return {
      paths,
      fallback: false,
    };
  } catch (err) {
    console.log(err);
    return { paths: [], fallback: false };
  }
}
